import * as React from 'react';
import s from './ProductHat.scss';
import classNames from 'classnames';
import { withExperiments } from '@wix/wix-experiments-react';
import { Text } from 'wix-style-react';
import { withInjectedRootStore } from 'providers';
import { ProductHatController, ProductHatProps } from './ProductHat.controller';
import { useTranslation } from 'react-i18next';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import { AdvancedPlansProductModel } from 'models/AdvancedPlansProductModel';
import { getSaleDiscountPercentage } from 'utils';

const ProductHatComp: React.FC<ProductHatProps> = (props) => {
  const controller = React.useMemo(() => new ProductHatController(props), []);
  const { product, rootStore, isMobile = false } = props;
  const { isInSale, experiments } = rootStore.appStore;
  const hatKey = controller.hatKey;
  const isCurrentPlan = hatKey === 'productEntry.current_plan.hat';

  const { t } = useTranslation();
  const { theme: themeName } = usePageModeContext();

  const discountPercentage = getSaleDiscountPercentage(
    experiments,
    product as AdvancedPlansProductModel,
  );

  return (
    <div
      className={classNames(
        {
          [s.popularHeader]: !isMobile,
          [s.mobilePopularHeader]: isMobile,
          [s.visible]: !!hatKey,
          [s.saleWrapper]: isInSale && !isCurrentPlan,
        },
        themeName,
      )}
      data-hook='product-hat'
    >
      <Text
        className={classNames({
          [s.sale]: !!discountPercentage && isInSale && !isCurrentPlan,
          [s.mobileHat]: isMobile,
        })}
        dataHook='hat-text'
        data-testid='hat-text'
        skin={isCurrentPlan ? 'standard' : 'premium'}
        secondary={isCurrentPlan}
        weight='bold'
        size='tiny'
      >
        {t(hatKey, {
          percent:
            discountPercentage && product.isProductInSale
              ? discountPercentage
              : product.getDiscountPercent() ?? '',
        })}
      </Text>
    </div>
  );
};

export const ProductHat = withInjectedRootStore(
  withExperiments(ProductHatComp),
);
